import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import {SystemStatus} from "../../../gd/const/system-status"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectTaskSystemStatus
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/task-system-status"
import Views_convertStatusStringToStatuses from "../../functions/convert-string-to-statuses"
import Views_convertStatusesToStatusString from "../../functions/convert-statuses-to-string"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

type GanttConditionsType = {
    projects            : ID[]
    systemTaskStatuses  : SystemStatus[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: GanttConditionsType):void }
}

// const debug = "ViewGantt_Conditions"
const debug = false

export default function ViewGantt_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: GanttConditionsType = {
            projects            : result.projects,
            systemTaskStatuses  : Views_convertStatusStringToStatuses(result.systemTaskStatuses)
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects            : conditions?.projects || [],
        systemTaskStatuses  : Views_convertStatusesToStatusString(conditions?.systemTaskStatuses),
    }

    const formStructure = {
        fields          : {
            projects            : { type: 'select',   isRequired: false,  label: 'Projects'},
            systemTaskStatuses  : { type: 'select',   isRequired: false,  label: 'System task statuses',    onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData);

    const classes = Classes("ui5-form", props.className)

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectTaskSystemStatus form            = {form}
                                        formFieldName   = 'systemTaskStatuses'
                                        disabled        = {props.disabled}/>
            </div>
        </div>
    )
}
